import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { getJwtToken, UploadFile, UploadSiteFile } from "../../Redux/AdminReducer/action";
import { useNavigate } from "react-router-dom";
import { END_POINT } from "../../Redux/AdminReducer/action";
import RightWrapper from "../../Components/CommonComponents/ComponentWrapper";
import axios from "axios";
import { MultipleFileUploads } from "../../Components/CommonComponents/DoctorUploadModals";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useGetLoggedInUser } from "../../UtilityHookFunctions/LoggedInUser";

const postItem = async (data, path, tenant) => {
  try {
    const result = await axios.post(`${END_POINT}/site_config/` + path, data, {
      headers: {
        Authorization: getJwtToken(),
        tenant: tenant,
      },
    });
    toast.success(result?.data?.message || "site updated successfully");
  } catch (error) {
    toast.error(error?.response?.data || "Something went wrong");
    console.error(error);
  }
};

const fetchItem = async (path) => {
  try {
    const result = await axios.get(`${END_POINT}/site_config/` + path, {
      headers: {
        Authorization: getJwtToken(),
      },
    });
    return result.data;
  } catch (error) {
    toast.error(error?.response?.data || "Something went wrong");
    console.error(error);
  }
};

const SiteConfig = () => {
  const [isMultipleModalOpen, setIsMultipleModalOpen] = useState(false);
  const [uploadType, setUploadType] = useState(null);
  const [pages, setPages] = useState(null);
  const [currentPage, setCurrentPage] = useState();
  const [currentSection, setCurrentSection] = useState();
  const [modifiedData, setModifiedData] = useState({});
  const [site, setsite] = useState({});
  const user = useGetLoggedInUser();
  const [createSite, setCreateSite] = useState({ domain: "", created: false });


  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchConfig = async () => {
    const tenant = site?.site;
    if (!tenant) {
      toast.error("Tenant is required");
      return;
    }
    const configData = await fetchItem(`${tenant}`);
    if (configData) {
      setPages(configData);
      setCurrentPage(Object.keys(configData)[0]);
      setCurrentSection(Object.keys(configData[Object.keys(configData)[0]])[0]);

      console.log("Config Data:", configData);
    }
  };

  useEffect(() => {
    if(site){
      fetchConfig();
    }
  }, [site])

  useEffect(() => {
    fetchItem(`/tenant/getsite/${user?._id}`)
      .then((data) => {
        const siteData = data;
        setsite(siteData);
        console.log("Site Data:", siteData);
      })
      .catch((error) => {
        console.error("Error fetching site data:", error);
      });
  }, []);

  const openMultipleUploadModal = () => {
    setUploadType("images");
    setIsMultipleModalOpen(true);
  };

  const handleCloseMultipleModal = () => setIsMultipleModalOpen(false);

  const handleMultipleFileUploads = async (files) => {
    try {
      dispatch(UploadSiteFile(files, "client1", "images"));
      toast.success("Images uploaded successfully");
      handleCloseMultipleModal();
    } catch (error) {
      toast.error("Failed to upload images");
    }
  };

  const saveConfig = async () => {
    let tenant = site.site;
    if (!tenant) {
      toast.error("Tenant is required");
      return;
    } else {
      await postItem(modifiedData, "upload-data", site.site);
      fetchConfig();
    }
  };

  const handleValueChange = (key, newVal) => {
    setPages((prev) => ({
      ...prev,
      [currentPage]: {
        ...prev[currentPage],
        [currentSection]: {
          ...prev[currentPage][currentSection],
          [key]: newVal,
        },
      },
    }));

    setModifiedData((prev) => {
      const pageChanges = prev[currentPage] || {};
      const sectionChanges = pageChanges[currentSection] || {};

      return {
        ...prev,
        [currentPage]: {
          ...pageChanges,
          [currentSection]: {
            ...sectionChanges,
            [key]: newVal,
          },
        },
      };
    });
  };

  return (
    <RightWrapper>
      <button onClick={() => navigate(-1)} className="bg-blue-800 hover:bg-blue-700 rounded-lg font-semibold text-white p-2 px-3 transition duration-300">
        Back
      </button>

      <>
        {pages === null && site?.site ? (
          <h3 className="text-black text-3xl font-semibold mt-3">Loading...</h3>
        ) : site?.site ? (
          <>
            <h3 className="text-black text-3xl font-semibold mt-3">Site Config</h3>
            <h4 className="text-xl font-semibold mt-4">
              Site Name: <span className="text-blue-600">{site?.site}</span>
            </h4>
            
            <button onClick={openMultipleUploadModal} className="mt-4 ml-4 bg-purple-600 hover:bg-purple-500 px-4 py-2 rounded text-white transition duration-300">
              Upload Multiple Images
            </button>

            <MultipleFileUploads isOpen={isMultipleModalOpen} closeModal={handleCloseMultipleModal} onFileUpload={handleMultipleFileUploads} uploadType={uploadType} />

            <div className="flex gap-2 mb-4 flex-wrap mt-10">
              {Object.keys(pages).map((page) => (
                <button
                  key={page}
                  onClick={() => {
                    setCurrentPage(page);
                    const firstSection = Object.keys(pages[page])[0];
                    setCurrentSection(firstSection);
                  }}
                  className={`px-4 py-1 rounded font-semibold transition duration-300 ${page === currentPage ? "bg-blue-700 text-white hover:bg-blue-600" : "bg-gray-300 hover:bg-gray-400"}`}
                >
                  {page}
                </button>
              ))}
            </div>

            <div className="flex gap-2 mb-4 flex-wrap">
              {Object.keys(pages[currentPage]).map((section) => (
                <button key={section} onClick={() => setCurrentSection(section)} className={`px-4 py-1 rounded font-semibold transition duration-300 ${section === currentSection ? "bg-green-700 text-white hover:bg-green-600" : "bg-gray-300 hover:bg-gray-400"}`}>
                  {section}
                </button>
              ))}
            </div>

            {Object.entries(pages[currentPage][currentSection]).map(([key, value]) => (
              <div key={key} className="flex items-center mb-2 gap-2">
                <input type="text" value={key} disabled className="border p-1 rounded w-1/3 bg-gray-200 cursor-not-allowed" />
                <input type="text" value={value} disabled={key === "tenant" || key === "logo"} onChange={(e) => handleValueChange(key, e.target.value)} placeholder={`Enter ${key}`} className="border p-1 rounded w-1/2" />
              </div>
            ))}

            <div className="mt-6">
              <button onClick={saveConfig} className="bg-green-600 hover:bg-green-500 text-white px-4 py-2 rounded font-semibold transition duration-300">
                Save Config
              </button>
            </div>

            <div className="mt-6">
              <button
                onClick={() => {
                  const siteUrl = `${window.location.protocol}//${site.site}.${window.location.host}/home`;
                  window.open(siteUrl, "_blank");
                }}
                className="bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded font-semibold transition duration-300"
                >
                Visit Site
                </button>
              </div>
              </>
            ) : user?.role === "MainDoctor" ? (
              <>
              <h3 className="text-black text-3xl font-semibold mt-3">Create New Site</h3>
              <div className="mt-4">
                <input type="text" placeholder="Enter Site Domain" className="border p-2 rounded w-full" onChange={(e) => setCreateSite((prev) => ({ ...prev, domain: e.target.value, created: true }))} />
                <button
                onClick={async () => {
                  if (!createSite?.domain) {
                    toast.error("Site domain is required");
                    return;
                  }
                  try {
                    const newSite = { sitedomain: createSite.domain, user_id: user?._id };
                    await postItem(newSite, "create_site", "any");
                    toast.success("Site created successfully");
                    fetchConfig();
                  } catch (error) {
                    toast.error("Failed to create site");
                  }
                }}
                className="bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded mt-2 transition duration-300"
              >
                Create Site
              </button>
            </div>
          </>
        ) : (
          <>
            <h3 className="text-black text-3xl font-semibold mt-3">Ask Main Doctor to create site</h3>
            {pages === null && (
              <div className="mt-4">
                <h4 className="text-xl font-semibold">No site configuration found.</h4>
              </div>
            )}
          </>
        )}
      </>
      <ToastContainer />
    </RightWrapper>
  );
};

export default SiteConfig;
